import type { SVGProps } from "react";

export function CheckMarkCircle02Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.4"
        d="M9 17.0625C4.5472 17.0625 0.9375 13.4528 0.9375 9C0.9375 4.5472 4.5472 0.9375 9 0.9375C13.4528 0.9375 17.0625 4.5472 17.0625 9C17.0625 13.4528 13.4528 17.0625 9 17.0625Z"
        fill="#60FFA2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5529 7.2568C12.8327 6.95146 12.8121 6.47703 12.5068 6.19714C12.2014 5.91725 11.727 5.93787 11.4471 6.24321L7.85145 10.1658L6.53033 8.84468C6.23744 8.5518 5.76257 8.5518 5.46967 8.84468C5.17678 9.13755 5.17678 9.61245 5.46967 9.90533L7.34467 11.7803C7.48932 11.925 7.68675 12.0043 7.89127 11.9999C8.0958 11.9954 8.2896 11.9076 8.4279 11.7568L12.5529 7.2568Z"
        fill="#60FFA2"
      />
    </svg>
  );
}
